const useFacebookPixel = () => {
  const sendFbq = (
    eventName: string,
    attr?: string,
    customEventType?: string
  ) => {
    if (typeof fbq !== "function") return;
    fbq(eventName, attr ?? null, customEventType ?? null);
  };

  return { sendFbq };
};

export default useFacebookPixel;
